module.exports = __webpack_public_path__ + "img/RX1HS4X6_PM_E_Large.46ac61a0.jpg";